import { lazy } from "react";
import DefaultLayout from "~/layouts/DefaultLayout";
import LoginLayout from "~/layouts/LoginLayout";
import { Routes, Route, Navigate } from "react-router";
import ProtectedRoute from "~/components/router/ProtectedRoute";
import PermissionGuard from "~/components/router/PermissionGuard";
import { Permission } from "~/helpers/permissions.helper";

const LoginPage = lazy(() => import("~/pages/login"));
const ReportListPage = lazy(() => import("~/pages/report/list"));
const ReportDetailsPage = lazy(() => import("~/pages/report/details"));
const AccountPage = lazy(() => import("~/pages/account"));
const NoPermissionPage = lazy(() => import("~/pages/no-permission"));

const Router = () => {
  return (
    <Routes>
      {/* Rotas públicas */}
      <Route element={<LoginLayout />}>
        <Route path="/login" element={<LoginPage />} />
      </Route>

      {/* Rotas protegidas por autenticação */}
      <Route element={<ProtectedRoute />}>
        {/* Alias do redirect pós-login do Keycloak (FRONTEND_REDIRECT_URL termina em
            /dashboard). Sem esta rota, o callback OAuth e o link de convite caem em
            tela em branco porque nada casa no Routes. */}
        <Route path="/dashboard" element={<Navigate to="/" replace />} />
        <Route element={<DefaultLayout />}>
          {/* Página inicial - requer permissão para visualizar lista de relatórios */}
          <Route
            path="/"
            element={
              <PermissionGuard requiredPermission={Permission.VIEW_REPORT_LIST}>
                <ReportListPage />
              </PermissionGuard>
            }
          />

          {/* Pasta - requer permissão para visualizar lista de relatórios */}
          <Route
            path="/pasta/:folderId"
            element={
              <PermissionGuard requiredPermission={Permission.VIEW_REPORT_LIST}>
                <ReportListPage />
              </PermissionGuard>
            }
          />

          {/* Detalhes do relatório - requer permissão para visualizar detalhes */}
          <Route
            path="report/:type/:id"
            element={
              <PermissionGuard requiredPermission={Permission.VIEW_REPORT_DETAILS}>
                <ReportDetailsPage />
              </PermissionGuard>
            }
          />

          {/* Configurações da conta - sempre acessível para usuários autenticados */}
          <Route
            path="/conta/configuracoes"
            element={<AccountPage />}
          />

          {/* Suporte da conta - sempre acessível para usuários autenticados */}
          <Route
            path="/conta/suporte"
            element={<AccountPage />}
          />

          {/* Página quando usuário não tem acesso a rota - sem permissão - sempre acessível para usuários autenticados */}
          <Route path="/sem-permissao" element={<NoPermissionPage />} />
        </Route>
      </Route>
    </Routes>
  );
};

export default Router;
